import React from 'react';
import { I18nUtils } from '../../../i18n/I18nUtils';
import { PsPage } from '../../shared/components/ps-page/PsPage';
import { Widgets } from '../widgets/Widgets';
import { DashboardStorageManagerInstance } from '../DashboardStorageManager';
import { PsCompanyManagement } from '../../shared/model/PsCompanyManagement';
import { DocumentsCards } from '../../shared/document/list/DocumentsCards';
import { MessagesCard } from '../../shared/message/list/MessagesCard';
import { OutsourceListCard } from '../../my-outsources/outsource/list/OutsourceListCard';
import WorkListCard from '../../shared/work/list/WorkListCard';
import PropTypes from 'prop-types';

export class MyOutsourcesManagerDashboard extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            dashboardState: null,
        };
    }

    componentDidUpdate(_, prevState) {
        const { dashboardState } = this.state;

        if ( prevState.dashboardState !== dashboardState ) {
            DashboardStorageManagerInstance.saveDocCardFilter('myOutsources', dashboardState);
        }
    }

    render() {
        const { breadcrumbs } = this.props;
        const { dashboardState } = this.state;
        const title = `${I18nUtils.tr('TR_INICIO')} - ${I18nUtils.tr('TR_MIS_SUBCONTRATAS')}`;

        return (
            <PsPage title={title} breadcrumbs={breadcrumbs}>
                <Widgets
                    onFilter={this.filterDashboardState}
                    companyManagement={PsCompanyManagement.MY_OUTSOURCES}
                />
                <DocumentsCards
                    dashboardState={dashboardState}
                    companyManagement={PsCompanyManagement.MY_OUTSOURCES}
                    saveCardState={this.saveCardState}
                    readCardState={this.readCardState}
                />
                <OutsourceListCard
                    saveCardState={(collapsed) => this.saveCardState('outsources', collapsed)}
                    initialCardState={this.readCardState('outsources')}
                />
                <WorkListCard
                    companyManagement={PsCompanyManagement.MY_OUTSOURCES}
                    saveCardState={(collapsed) => this.saveCardState('works', collapsed)}
                    initialCardState={this.readCardState('works')}
                />
                {/*<CompanyUpdateCard*/}
                {/*    saveCardState={(collapsed) => this.saveCardState('company', collapsed)}*/}
                {/*    initialCardState={this.readCardState('company')}*/}
                {/*/>*/}
                <MessagesCard
                    canAddMessage={false}
                    canResponseMessage={false}
                    saveCardState={(collapsed) => this.saveCardState('messages', collapsed)}
                    initialCardState={this.readCardState('messages')}
                />
            </PsPage>
        );
    }

    readCardState = (card) => {
        return DashboardStorageManagerInstance.readCard('myOutsources', card);
    };

    saveCardState = (card, state) => {
        DashboardStorageManagerInstance.saveCard('myOutsources', card, state);
    };

    filterDashboardState = (dashboardState) => {
        this.setState({ dashboardState });
    };
}

MyOutsourcesManagerDashboard.propTypes = {
    breadcrumbs: PropTypes.array.isRequired,
};

MyOutsourcesManagerDashboard.defaultProps = {};



// WEBPACK FOOTER //
// ./src/app/dashboard/dashboards/MyOutsourcesManagerDashboard.jsx